import {PageFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import {ChatParticipant, ChatParticipantFactory, ChatThread} from "./chat/types";

export type BaseChatThreadFragmentProps = PageFragmentProps & {
  thread: ChatThread,
}

export type BaseChatThreadFragmentState = PageFragmentState & {
  participants: ChatParticipant[],
}

export abstract class BaseChatThreadFragment<P extends BaseChatThreadFragmentProps = BaseChatThreadFragmentProps, S extends BaseChatThreadFragmentState = BaseChatThreadFragmentState> extends PageFragment<P, S> {

  componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot?: any) {
    super.componentDidUpdate(prevProps, prevState, snapshot);
    if (prevProps.thread.id !== this.props.thread.id) {
      this.reload();
    }
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    const participants: ChatParticipant[] = [];
    for (const key of this.props.thread.participantKeys) {
      participants.push(await ChatParticipantFactory.INSTANCE.loadParticipant(key));
    }
    this.setState({
      participants: participants,
    });
  }
}